var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map_wrapper"},[_c('div',{staticClass:"points-info"},[_c('h5',[_vm._v(_vm._s(_vm.$t('PLACEHOLDERS.click_to_add_points')))])]),_c('GmapMap',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.mapCenter,"zoom":12,"map-type-id":"terrain"},on:{"click":_vm.onMapClick}},[_vm._l((_vm.points),function(point,index){return _c('GmapMarker',{key:'marker-' + index,attrs:{"position":{ lat: parseFloat(point.lat), lng: parseFloat(point.lng) },"clickable":_vm.disabledMap ? false : true,"draggable":_vm.disabledMap ? false : true,"label":{
        text: (index + 1).toString(),
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold'
      }},on:{"click":function($event){return _vm.removePoint(index)},"dragend":(event) => _vm.onMarkerDragEnd(event, index)}})}),(_vm.points.length >= 3)?_c('GmapPolygon',{attrs:{"paths":_vm.polygonPath,"options":{
        fillColor: '#814686',
        fillOpacity: 0.35,
        strokeColor: '#814686',
        strokeOpacity: 0.8,
        strokeWeight: 3
      }}}):_vm._e(),(_vm.points.length >= 2 && _vm.points.length < 3)?_c('GmapPolyline',{attrs:{"path":_vm.polygonPath,"options":{
        strokeColor: '#814686',
        strokeOpacity: 0.8,
        strokeWeight: 3
      }}}):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }